module.exports = __webpack_public_path__ + "files/2cb077893ffab32e21f37f90822aaedf.png";